import { useState } from 'react';
import { registerMailSubscriber } from '../api';
import swal from 'sweetalert2';

const subjectOptions = [
    "Constitutional Law",
    "Criminal Law",
    "Civil Law",
    "Corporate & Commercial Law",
    "Taxation Law",
    "Labour & Employment Law",
    "Intellectual Property Law",
    "Environmental Law",
    "Family Law",
    "Banking & Finance Law",
    "Arbitration & ADR",
    "Human Rights Law",
    "Cyber Law & IT Act",
    "International Law",
    "Other"
];

export default function RegisterMailUpdatePage() {
    const [form, setForm] = useState({ name: '', email: '', mobile: '', subjectOfInterest: '' });
    const [sending, setSending] = useState(false);
    const [customSubject, setCustomSubject] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSending(true);

        const subject = form.subjectOfInterest === 'Other' ? customSubject : form.subjectOfInterest;

        if (!form.name || !form.email || !form.mobile || !subject) {
            swal.fire('Missing Fields', 'Please fill in all fields.', 'warning');
            setSending(false);
            return;
        }

        try {
            await registerMailSubscriber({
                name: form.name,
                email: form.email,
                mobile: form.mobile,
                subjectOfInterest: subject,
            });
            swal.fire({
                icon: 'success',
                title: 'Registered Successfully!',
                text: 'You will now receive e-mail updates on your selected subject.',
                confirmButtonColor: '#C0392B',
            });
            setForm({ name: '', email: '', mobile: '', subjectOfInterest: '' });
            setCustomSubject('');
        } catch (err) {
            swal.fire({
                icon: 'error',
                title: 'Registration Failed',
                text: err.message || 'Something went wrong. Please try again.',
                confirmButtonColor: '#C0392B',
            });
        } finally {
            setSending(false);
        }
    };

    const inputStyle = {
        width: "100%", padding: "14px 18px", borderRadius: 12,
        border: "1.5px solid #f0d0c8", background: "#fff8f8",
        fontFamily: "'Nunito Sans',sans-serif", fontSize: 14,
        outline: "none", color: "#1a0505", transition: "border-color 0.25s, box-shadow 0.25s",
        display: "block", boxSizing: "border-box"
    };
    const focusStyle = (e) => {
        e.target.style.borderColor = "#C0392B";
        e.target.style.boxShadow = "0 0 0 3px rgba(192,57,43,0.12)";
    };
    const blurStyle = (e) => {
        e.target.style.borderColor = "#f0d0c8";
        e.target.style.boxShadow = "none";
    };

    return (
        <div style={{ background: "#FDF5F5", minHeight: "80vh" }}>
            <style>{`
                @media (max-width: 900px) {
                    .mail-register-grid { grid-template-columns: 1fr !important; gap: 32px !important; }
                    .mail-register-section { padding: 40px 20px !important; }
                    .mail-register-info { padding: 32px !important; }
                }
            `}</style>

            {/* Hero banner */}
            <div style={{
                background: "linear-gradient(135deg, #6B1A1A 0%, #521010 50%, #611515 100%)",
                padding: "64px 40px 56px",
                textAlign: "center",
                position: "relative",
                overflow: "hidden"
            }}>
                {/* Decorative dots */}
                <div style={{
                    position: "absolute", inset: 0,
                    backgroundImage: "radial-gradient(circle, rgba(255,255,255,0.08) 1.5px, transparent 1.5px)",
                    backgroundSize: "28px 28px", pointerEvents: "none"
                }} />
                {/* Glow */}
                <div style={{
                    position: "absolute", top: -60, right: -60, width: 260, height: 260,
                    borderRadius: "50%",
                    background: "radial-gradient(circle, rgba(232,82,58,0.2), transparent 70%)",
                    pointerEvents: "none"
                }} />
                <div style={{
                    position: "absolute", bottom: -40, left: -40, width: 200, height: 200,
                    borderRadius: "50%",
                    background: "radial-gradient(circle, rgba(245,166,35,0.15), transparent 70%)",
                    pointerEvents: "none"
                }} />

                <div style={{ position: "relative", zIndex: 1 }}>

                    <h1 style={{
                        fontFamily: "'Playfair Display',serif", fontSize: 38, fontWeight: 800,
                        color: "white", lineHeight: 1.2, marginBottom: 12,
                        animation: "fadeUp 0.6s cubic-bezier(0.16,1,0.3,1) both"
                    }}>
                        Registered for{' '}
                        <span style={{ color: "#F5A623", fontStyle: "italic" }}>E-mail Update</span>
                    </h1>
                    <p style={{
                        color: "rgba(255,255,255,0.7)", fontSize: 15, maxWidth: 540, margin: "0 auto",
                        lineHeight: 1.7,
                        animation: "fadeUp 0.6s 0.1s cubic-bezier(0.16,1,0.3,1) both"
                    }}>
                        Register to receive the latest updates, new publications, and insights
                        on legal subjects that matter to you.
                    </p>
                </div>
            </div>

            {/* Form section */}
            <section className="mail-register-section" style={{ padding: "64px 72px" }}>
                <div className="mail-register-grid" style={{
                    display: "grid", gridTemplateColumns: "1fr 1.6fr",
                    gap: 56, maxWidth: 1000, margin: "0 auto", alignItems: "start"
                }}>
                    {/* Left: Info panel */}
                    <div className="mail-register-info" style={{
                        background: "linear-gradient(135deg, #6B1A1A 0%, #521010 60%, #611515 100%)",
                        borderRadius: 24, padding: 40, position: "relative", overflow: "hidden",
                        boxShadow: "0 16px 48px rgba(192,57,43,0.25)"
                    }}>
                        {/* Dot pattern */}
                        <div style={{
                            position: "absolute", inset: 0,
                            backgroundImage: "radial-gradient(circle, rgba(255,255,255,0.08) 1.5px, transparent 1.5px)",
                            backgroundSize: "22px 22px", pointerEvents: "none"
                        }} />
                        {/* Glow accent */}
                        <div style={{
                            position: "absolute", top: -30, right: -30, width: 160, height: 160,
                            borderRadius: "50%",
                            background: "radial-gradient(circle, rgba(232,82,58,0.2), transparent 70%)",
                            pointerEvents: "none"
                        }} />

                        <div style={{ position: "relative", zIndex: 1 }}>
                            <div style={{
                                width: 56, height: 56, borderRadius: 16,
                                background: "rgba(245,166,35,0.15)", border: "1px solid rgba(245,166,35,0.3)",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                marginBottom: 24, fontSize: 26
                            }}>✉️</div>

                            <h3 style={{
                                fontFamily: "'Playfair Display',serif", fontSize: 24, fontWeight: 800,
                                color: "white", marginBottom: 12, lineHeight: 1.2
                            }}>
                                Why{' '}
                                <span style={{ color: "#F5A623", fontStyle: "italic" }}>Register?</span>
                            </h3>
                            <p style={{
                                color: "rgba(255,255,255,0.7)", fontSize: 13.5, lineHeight: 1.8, marginBottom: 32
                            }}>
                                You may register yourself for receiving updates regarding new releases and other important news.
                            </p>

                            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
                                {[
                                    { title: "New Publications", desc: "Be first to know about new releases" },
                                    { title: "Legal Updates", desc: "Stay current with law amendments" },
                                    { title: "Tailored Content", desc: "Updates matching your interests" },
                                ].map((item, i) => (
                                    <div key={i} style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
                                        <div>
                                            <div style={{
                                                color: "rgba(255,255,255,0.95)", fontSize: 13, fontWeight: 700,
                                                marginBottom: 2
                                            }}>{item.title}</div>
                                            <div style={{
                                                color: "rgba(255,255,255,0.6)", fontSize: 12, lineHeight: 1.5
                                            }}>{item.desc}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Right: Form */}
                    <div style={{
                        background: "white", borderRadius: 24,
                        border: "1.5px solid #f0d0c8", padding: 40,
                        boxShadow: "0 10px 40px rgba(192,57,43,0.08)", overflow: "hidden", position: "relative"
                    }}>
                        {/* Top accent bar */}
                        <div style={{
                            height: 3,
                            background: "linear-gradient(90deg, #C0392B, #F5A623)",
                            margin: "-40px -40px 32px"
                        }} />

                        <div style={{ marginBottom: 28 }}>
                            <h3 style={{
                                fontFamily: "'Playfair Display',serif", fontSize: 26, fontWeight: 800,
                                color: "#1a0505", lineHeight: 1.15
                            }}>
                                Get{' '}
                                <span style={{ color: "#C0392B", fontStyle: "italic" }}>E-mail Updates</span>
                            </h3>
                        </div>

                        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 18 }}>
                            <div>
                                <label style={{
                                    display: "block", fontSize: 12, fontWeight: 700,
                                    color: "#8B4A4A", marginBottom: 6, letterSpacing: "0.04em"
                                }}>FULL NAME</label>
                                <input
                                    id="mail-register-name"
                                    required type="text" name="name"
                                    placeholder="Enter your full name"
                                    value={form.name}
                                    onChange={handleChange}
                                    style={inputStyle}
                                    onFocus={focusStyle}
                                    onBlur={blurStyle}
                                />
                            </div>

                            <div>
                                <label style={{
                                    display: "block", fontSize: 12, fontWeight: 700,
                                    color: "#8B4A4A", marginBottom: 6, letterSpacing: "0.04em"
                                }}>EMAIL ADDRESS</label>
                                <input
                                    id="mail-register-email"
                                    required type="email" name="email"
                                    placeholder="you@email.com"
                                    value={form.email}
                                    onChange={handleChange}
                                    style={inputStyle}
                                    onFocus={focusStyle}
                                    onBlur={blurStyle}
                                />
                            </div>

                            <div>
                                <label style={{
                                    display: "block", fontSize: 12, fontWeight: 700,
                                    color: "#8B4A4A", marginBottom: 6, letterSpacing: "0.04em"
                                }}>MOBILE NUMBER</label>
                                <input
                                    id="mail-register-mobile"
                                    required type="tel" name="mobile"
                                    placeholder="Enter your mobile number"
                                    value={form.mobile}
                                    onChange={handleChange}
                                    style={inputStyle}
                                    onFocus={focusStyle}
                                    onBlur={blurStyle}
                                />
                            </div>

                            <div>
                                <label style={{
                                    display: "block", fontSize: 12, fontWeight: 700,
                                    color: "#8B4A4A", marginBottom: 6, letterSpacing: "0.04em"
                                }}>SUBJECT OF INTEREST</label>
                                <select
                                    id="mail-register-subject"
                                    required name="subjectOfInterest"
                                    value={form.subjectOfInterest}
                                    onChange={handleChange}
                                    style={{
                                        ...inputStyle,
                                        cursor: "pointer",
                                        appearance: "none",
                                        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23C0392B' d='M2 4l4 4 4-4'/%3E%3C/svg%3E")`,
                                        backgroundRepeat: "no-repeat",
                                        backgroundPosition: "right 16px center",
                                        paddingRight: 40,
                                    }}
                                    onFocus={focusStyle}
                                    onBlur={blurStyle}
                                >
                                    <option value="">Select a subject...</option>
                                    {subjectOptions.map(opt => (
                                        <option key={opt} value={opt}>{opt}</option>
                                    ))}
                                </select>
                            </div>

                            {form.subjectOfInterest === 'Other' && (
                                <div style={{ animation: "fadeUp 0.3s ease both" }}>
                                    <label style={{
                                        display: "block", fontSize: 12, fontWeight: 700,
                                        color: "#8B4A4A", marginBottom: 6, letterSpacing: "0.04em"
                                    }}>SPECIFY SUBJECT</label>
                                    <input
                                        id="mail-register-custom-subject"
                                        required type="text"
                                        placeholder="Type your subject of interest..."
                                        value={customSubject}
                                        onChange={(e) => setCustomSubject(e.target.value)}
                                        style={inputStyle}
                                        onFocus={focusStyle}
                                        onBlur={blurStyle}
                                    />
                                </div>
                            )}

                            <button
                                id="mail-register-submit"
                                type="submit"
                                disabled={sending}
                                style={{
                                    padding: "15px", fontSize: 15, fontWeight: 700,
                                    background: sending
                                        ? "#ccc"
                                        : "linear-gradient(135deg, #C0392B, #96221A)",
                                    color: "white", border: "none", borderRadius: 12,
                                    cursor: sending ? "not-allowed" : "pointer",
                                    fontFamily: "'Nunito Sans',sans-serif",
                                    boxShadow: "0 4px 18px rgba(192,57,43,0.35)",
                                    transition: "all 0.25s",
                                    marginTop: 4
                                }}
                                onMouseEnter={(e) => {
                                    if (!sending) e.target.style.transform = "translateY(-2px)";
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = "translateY(0)";
                                }}
                            >
                                {sending ? (
                                    <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                                        <span style={{
                                            width: 16, height: 16, borderRadius: "50%",
                                            border: "2px solid rgba(255,255,255,0.3)",
                                            borderTopColor: "white", display: "inline-block",
                                            animation: "spin 0.8s linear infinite"
                                        }} />
                                        Registering...
                                    </span>
                                ) : "Register for Updates →"}
                            </button>

                            <p style={{
                                fontSize: 12, color: "#9a6a6a", textAlign: "center",
                                lineHeight: 1.6, marginTop: 4
                            }}>
                                We respect your privacy. Unsubscribe anytime.
                            </p>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
}
